
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M18.9 14.138l4.839-2.403a.47.47 0 00-.07-.87l-7.844-2.44a.47.47 0 00-.28.899l6.724 2.09-4.373 2.173a.47.47 0 00-.124.754l5.074 5.074-3.431 3.431-5.074-5.074a.471.471 0 00-.755.124l-2.172 4.373L6.516 6.516l5.428 1.688a.47.47 0 00.28-.899L5.941 5.352a.47.47 0 00-.59.589l5.513 17.728a.47.47 0 00.871.07l2.403-4.838 4.944 4.943a.47.47 0 00.665 0l4.097-4.097a.47.47 0 000-.665l-4.943-4.944z","fill":"#00003C"}}),_c('path',{staticClass:"active-highlight",attrs:{"d":"M2.365 1.699a.47.47 0 00-.666.666L2.895 3.56a.47.47 0 00.666 0 .47.47 0 000-.666L2.365 1.7zM8.374 3.699a.47.47 0 00.332-.138l1.197-1.196a.47.47 0 00-.666-.666L8.041 2.895a.47.47 0 00.333.804zM2.895 8.04L1.7 9.238a.47.47 0 10.665.666l1.197-1.197a.47.47 0 10-.666-.665zM5.801 2.633c.26 0 .47-.21.47-.47V.47a.47.47 0 00-.94 0v1.691c0 .26.21.471.47.471zM2.633 5.801a.47.47 0 00-.47-.47H.47a.47.47 0 000 .94h1.691c.26 0 .471-.21.471-.47zM13.447 8.493a.476.476 0 00.466.29.474.474 0 00.423-.348.473.473 0 00-.188-.51.475.475 0 00-.527-.004.475.475 0 00-.174.572z","fill":"#E2E4EC"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"d":"M0 0h24v24H0V0z","fill":"#fff"}})])])])
          )
        }
      }
    